<template>
  <nav class="uk-navbar-container" id="menu-modal-parent" uk-navbar>
    <div class="uk-navbar-left">
      <ul class="uk-navbar-nav">
        <li class="logo">
          <img src="@/assets/logo_white.png" class="logo-image" />
        </li>
        <li v-for="navRow in navMenu" :key="navRow.id" :class="{ 'uk-active': activePath === navRow.id }">
          <router-link :to="navRow.path" v-html="navRow.name" />
          <div class="uk-navbar-dropdown" v-if="navRow.child">
            <ul class="uk-nav uk-navbar-dropdown-nav uk-nav-parent-icon" uk-nav="multiple: true">
              <NavBarRow v-for="node in navRow.child" :key="node.id" :node="node" />
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <div class="uk-navbar-right">
      <div class="uk-margin-right">
        <div class="uk-inline">
          <div class="bell-icon">
            <span uk-icon="icon: bell; ratio: 1.25"></span>
            <span class="uk-badge" v-if="unreadNotificationsCount">{{ unreadNotificationsCount }}</span>
          </div>
          <div class="uk-card uk-card-default uk-card-small" uk-drop="mode: click" ref="notificationsDrop">
            <div class="uk-card-body uk-overflow-auto">
              <dl class="uk-description-list uk-description-list-divider">
                <template v-if="!notifications.length">
                  新着なし
                </template>
                <template v-else v-for="notification in notifications" :key="notification.id">
                  <dt class="uk-flex uk-flex-middle" :class="{ 'uk-text-muted': notification.isRead }">
                    <span class="uk-label uk-margin-small-right" v-if="!notification.isRead">新規</span>
                    {{ notification.title }}
                  </dt>
                  <dd :class="{ 'uk-text-muted': notification.isRead }" v-html="notification.content"></dd>
                </template>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div class="personal-info">
        <p class="label">{{ fullName }} さん</p>
        <p class="label role-name" v-if="roleName">{{ roleName }}</p>
      </div>
      <div class="button">
        <div class="uk-inline">
          <Avatar :image="avatarImage" />
          <div uk-dropdown="mode: click" ref="dropdown">
            <template v-if="isClientAdmin">
              <ul class="uk-nav uk-navbar-dropdown-nav wrapper-info">
                <li>クライアントID: {{ clientId }}</li>
                <li>プラン名: {{ planName }}</li>
                <template v-if="!isTrial && planEnd">
                  <li>契約期間: {{ planEnd }}まで</li>
                  <li v-if="!isDeleteScheduled">(自動継続)</li>
                </template>
              </ul>
              <hr />
            </template>
            <ul class="uk-nav uk-navbar-dropdown-nav wrapper-actions">
              <li>
                <a href="https://static.serv.hyoumanbox.com/files/HYOUMAN_BOX_ユーザマニュアル.pdf" target="_blank">マニュアル</a>
              </li>
              <li v-if="storeInstance.getAuth()?.user.employeeId">
                <a href="javascript:void(0);" @click="onAvatarLinkClick">アイコン変更</a>
                <input
                  type="file"
                  style="display:none;"
                  @change="onAvatarSelect"
                  ref="avatarField"
                  :accept="acceptImageType.join()"
                />
              </li>
              <li>
                <a href="javascript:void(0);" @click="changePassword">パスワード変更</a>
              </li>
              <li>
                <a href="javascript:void(0);" @click="logout">ログアウト</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="uk-flex-top change-password-modal" uk-modal ref="modal" container="#menu-modal-parent" :bg-close="false">
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical form">
        <ChangePassword :key="formKey" @submitted="onSubmitted" @close="onClose" />
      </div>
    </div>
  </nav>
</template>
<style lang="scss" scoped>
.selector {
  width: 260px;
  padding: $spacing-ex-small;
}
.button {
  margin-right: $spacing-ex-small;
}
.uk-navbar {
  min-width: 1200px;
}
// global navi color correction when moving the cursor to the dropdown
.uk-navbar-left li:not(.uk-active):hover a {
  color: #fff;
}
div.uk-navbar-left li a {
  color: #fff;
  width: 120px;
  font-size: 0.76rem;
  border-bottom: 6px solid transparent;
  min-height: 64px;
  &:hover {
    color: $link-color-active;
  }
}
.uk-navbar .uk-active {
  color: $link-color-active;
  background-color: $brand-deep-color;
  a {
    border-bottom: 6px solid;
    color: $link-color-active;
  }
}
.uk-navbar-right {
  text-align: right;
  .label {
    font-size: 0.8em;
    color: #fff;
    padding-right: 1rem;
    margin: 0;
  }
  .role-name {
    text-overflow: ellipsis;
    display: block;
    overflow: hidden;
    max-width: 250px;
  }
  .wrapper-info {
    font-size: 0.75em;
    color: #999;
  }
  .wrapper-actions li a {
    color: #666;
  }
  .uk-drop {
    width: 400px;
    top: 20px;
    &:before {
      content: "";
      position: absolute;
      top: -22px;
      right: 2px;
      // margin-left: -10px;
      border-width: 11px;
      border-style: solid;
      border-color: transparent transparent #fff transparent;
    }
    > div {
      max-height: 70vh;
    }
  }
  .uk-card-body {
    text-align: left;
  }
}
.logo {
  width: 120px;
}
.logo-image {
  padding: 12px 12px 0 12px;
}
.bell-icon {
  cursor: pointer;
  .uk-icon {
    color: #fff;
  }
  .uk-badge {
    position: absolute;
    top: -6px;
    right: -4px;
    background: $error-color;
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    font-size: 0.75rem;
  }
}
// multiple navibar settings blow
:deep(.uk-navbar-dropdown) {
  padding: $spacing-ex-small - $spacing-minimum;
  background-color: #103c6e;
  & ul.uk-navbar-dropdown-nav li a {
    color: #fff;
    margin-right: 15px;
    &:hover {
      color: $link-color-active;
    }
  }
}
div[class*="uk-navbar-dropdown-bottom"] {
  margin-top: 0px;
  top: 0px;
}
:deep(.uk-navbar-dropdown-nav) {
  position: relative;
}
</style>
<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Watch, Ref } from "vue-property-decorator";
import { RouteLocation } from "vue-router";
import DropdownButton from "../atoms/DropdownButton.vue";
import Avatar from "../atoms/Avatar.vue";
import { toDepartmentPath, toClientPath } from "../../helpers/path-utils";
import {
  AuthApi,
  RoleName,
  SystemApi,
  GetPricePlan,
  PricePlanEnum,
  NavNode,
  Child,
  EmployeeApi,
  UpdateAvatar,
  NotificationsApi,
  NotificationLanguageEnum,
  NotificationContextEnum,
  Notification
} from "../../autogen";
import Store from "../../store";
import ChangePassword from "../organisms/ChangePassword.vue";
import UIkit from "uikit";
import * as RoleHelper from "../../helpers/role-helper";
import NavBarRow from "../molecules/NavBarRow.vue";
import { InstructionLevel, navMenu } from "../../types";

const ClientRelatedPaths = ["/analysis", "/as", "/organization", "/applicants", "/advance", "/users"];

declare module "@vue/runtime-core" {
  export interface ComponentCustomProperties {
    $role: typeof RoleHelper;
  }
}

@Options({
  components: { DropdownButton, Avatar, ChangePassword, NavBarRow }
})
export default class Menu extends Vue {
  private readonly storeInstance = Store.getInstance();
  departmentId = "all";
  activePath = "dashboard";
  formKey = 0;
  @Ref("modal") modal!: HTMLElement;
  @Ref("dropdown") dropdown!: HTMLElement;
  isTrial = true;
  priceResponse: GetPricePlan[] = [];
  planName = "";
  availableAdminFunc = RoleName.ClientAdmin;
  availableDepOwnerFunc = RoleName.DepartmentOwner;
  @Ref("avatarField") avatarField!: HTMLElement;
  imageMaxWidth = 200;
  acceptImageType = ["image/png", "image/jpeg"];
  avatarImage?: string | null = this.storeInstance.getAuth()?.user.image;
  @Ref("notificationsDrop") notificationsDrop!: HTMLElement;
  notifications: Notification[] = [];
  unreadNotificationsCount: number = 0;
  navMenu: navMenu[] = [];
  defalutNavMenu: navMenu[] = [
    {
      id: "dashboard",
      name: "ダッシュボード",
      path: `/clients/${this.clientId}/departments/${this.departmentId}/dashboard`,
      child: []
    },
    {
      id: "employees",
      name: "従業員<br />データベース",
      path: `/clients/${this.clientId}/departments/${this.departmentId}/employees`,
      child: []
    },
    {
      id: "applicants",
      name: "応募者<br />データベース",
      path: `/clients/${this.clientId}/applicants`,
      child: [
        { name: "全て", path: `/clients/${this.clientId}/applicants` },
        {
          name: "選考中",
          path: `/clients/${this.clientId}/applicants/?status=screening`
        },
        {
          name: "採用",
          path: `/clients/${this.clientId}/applicants/?status=hired`
        },
        {
          name: "不採用",
          path: `/clients/${this.clientId}/applicants/?status=not_hired`
        },
        {
          name: "入社",
          path: `/clients/${this.clientId}/applicants/?status=joined`
        }
      ]
    },
    {
      id: "analysis",
      name: "分析",
      path: `/clients/${this.clientId}/analysis`,
      child: [
        { name: "RD分析", path: `/clients/${this.clientId}/analysis/rd` },
        { name: "PD分析", path: `/clients/${this.clientId}/analysis/pd` },
        { name: "PM分析", path: `/clients/${this.clientId}/analysis/pm` },
        { name: "HS分析", path: `/clients/${this.clientId}/analysis/hs` },
        { name: "性格マトリクス", path: `/clients/${this.clientId}/analysis/personalityMatrix` },
        { name: "経年データ", path: `/clients/${this.clientId}/analysis/progress` }
      ]
    },
    {
      id: "as",
      name: "アセスメント<br />サーベイ",
      path: `/clients/${this.clientId}/as`
    },
    {
      id: "organization",
      name: "管理",
      path: `/clients/${this.clientId}/organization`,
      child: [
        { name: "部署管理", path: `/clients/${this.clientId}/organization/departments` },
        { name: "権限管理", path: `/clients/${this.clientId}/organization/authority` },
        { name: "役職管理", path: `/clients/${this.clientId}/organization/positions` },
        { name: "受検画面管理", path: `/clients/${this.clientId}/organization/exam` },
        { name: "メールテンプレート", path: `/clients/${this.clientId}/organization/mail_templates` },
        { name: "アクセス履歴", path: `/clients/${this.clientId}/organization/access_logs` },
        { name: "バックグラウンド処理状況", path: `/clients/${this.clientId}/organization/queue_manages` }
      ]
    },
    {
      id: "advance",
      name: "特別管理",
      path: `/clients/${this.clientId}/advance`,
      child: [
        { name: "タグ管理", path: `/clients/${this.clientId}/advance/tags` },
        { name: "人材基準管理", path: `/clients/${this.clientId}/advance/hr_criteria` },
        { name: "退職者一覧", path: `/clients/${this.clientId}/advance/retired` }
      ]
    },
    {
      id: "system",
      name: "システム設定",
      path: `/system`
    }
  ];
  get fullName() {
    const user = this.storeInstance.getAuth()?.user;
    return user ? `${user.lastName} ${user.firstName}` : "";
  }
  get isClientAdmin() {
    const role = this.storeInstance.getRole();
    return role && role.id === RoleName.ClientAdmin;
  }
  get roleName() {
    const role = this.storeInstance.getRole();
    return role ? role.name : "";
  }
  get clientId() {
    const auth = this.storeInstance.getAuth();
    return auth ? auth.clientId : "0";
  }
  get planEnd() {
    const auth = this.storeInstance.getAuth();
    if (auth && auth.pricePlan !== PricePlanEnum.Trial) {
      const date = auth.planEnd && new Date(auth.planEnd as string);
      return date ? `${date.getFullYear()}年${date.getMonth() + 1}月` : "";
    }
    return "";
  }
  get isDeleteScheduled() {
    const auth = this.storeInstance.getAuth();
    return auth && auth.isDeleteScheduled;
  }

  private belongsToClient(path: string) {
    return ClientRelatedPaths.some(p => path.indexOf(p) >= 0);
  }
  private setActive(to: string) {
    if (to === "/system") {
      this.activePath = "system";
    } else if (this.belongsToClient(to)) {
      const path = toClientPath(to);
      this.activePath = path.activePath.split("/")[0];
    } else {
      const path = toDepartmentPath(to);
      this.departmentId = path.departmentId;
      this.activePath = path.activePath;
    }
  }

  private async registerEvents() {
    this.notificationsDrop.addEventListener("shown", async () => {
      const unreadNotificationIds = this.notifications.filter(({ isRead }) => !isRead).map(({ id }) => id);
      if (unreadNotificationIds.length) {
        await new NotificationsApi().createNotificationReceipt({
          postNotificationReceipt: {
            notificationIds: unreadNotificationIds
          }
        });
      }
      this.unreadNotificationsCount = 0;
    });

    this.notificationsDrop.addEventListener("hidden", async () => {
      await this.loadNotifications();
    });
  }

  private async loadNotifications() {
    try {
      const response = await new NotificationsApi().getNotifications({
        language: NotificationLanguageEnum.jp,
        context: NotificationContextEnum.mgtScreen
      });
      this.notifications = response.data;
      this.unreadNotificationsCount = response.data.filter(({ isRead }) => !isRead).length;
    } catch (err) {
      console.log(err);
    }
  }
  @Watch("$route")
  onRouteChanged(to: RouteLocation) {
    this.setActive(to.path);
    this.navMenu = this.$role.setNavByRole(this.defalutNavMenu, this.isTrial)!;
    this.setDepartmentsOnNavi();
  }
  async beforeMount() {
    this.setActive(this.$route.path);
    const planCode = this.storeInstance.getAuth()!.pricePlan;
    this.isTrial = planCode === PricePlanEnum.Trial;
    this.navMenu = this.$role.setNavByRole(this.defalutNavMenu, this.isTrial)!;
    this.setDepartmentsOnNavi();
    if (!this.priceResponse.length) {
      const response = await new SystemApi().getPricePlans({});
      this.priceResponse = response.data;
    }
    if (this.priceResponse.length && this.$role.isStrongerThan(this.availableAdminFunc)) {
      const plan = Object.entries(this.priceResponse).find(([_, e]) => e.code === planCode);
      this.planName = plan ? plan[1].name : "";
    }

    await this.registerEvents();
    await this.loadNotifications();
  }
  @Watch("storeInstance.state.departments")
  stateDepartmentsChange() {
    this.setDepartmentsOnNavi();
  }
  @Watch("storeInstance.state.role.permissions")
  stateRoleChange() {
    this.navMenu = this.$role.setNavByRole(this.defalutNavMenu, this.isTrial)!;
    this.setDepartmentsOnNavi();
  }
  /**
   * ダッシュボード、従業員管理の部署階層セット
   */
  setDepartmentsOnNavi() {
    const deps = this.storeInstance.getDepartments({});
    this.navMenu.map(r => {
      if (r.id && ["employees", "dashboard"].includes(r.id)) {
        r.child = this.getdepartmentChildPath(deps, r.id);
      }
      return r;
    });
  }
  /**
   * get department child path
   * @param {Child[]} child 部署ノード
   * @return child path付きノード
   */
  getdepartmentChildPath(child: Child[], uri: string) {
    return child.map((r: Child) => {
      const menu = Object.assign({}, r, {
        path: `/clients/${this.clientId}/departments/${r.id}/${uri}`
      });
      if (r.child && r.child.length) {
        menu.child = this.getdepartmentChildPath(r.child, uri);
      }
      return menu;
    });
  }
  /**
   * get role child path
   * @param {navNode[]} navメニュー
   * @return navNode[] ログインユーザーが利用可能なナビメニュー
   */
  getRoleAvailable(navNode: NavNode[]) {
    // TODO create logic at role
    return navNode;
  }
  async logout() {
    await new AuthApi().logout({});
    Store.getInstance().setAuth(null);
    this.$router.push("/login");
  }
  changePassword() {
    this.formKey = Date.now();
    UIkit.modal(this.modal).show();
  }
  onSubmitted() {
    UIkit.modal(this.modal).hide();
  }
  onClose() {
    UIkit.modal(this.modal).hide();
  }
  onAvatarLinkClick() {
    this.avatarField.click();
  }
  async onAvatarSelect() {
    UIkit.dropdown(this.dropdown).hide();
    if (!this.storeInstance.getAuth()!.user.employeeId) return;
    const target = this.avatarField as HTMLInputElement;
    const file = target.files![0];
    const imageType = file.type;
    if (imageType && !this.acceptImageType.includes(imageType)) {
      this.storeInstance.setInstructionContent(InstructionLevel.Alert, "顔写真はPNG、JPEGのみアップロード可能です");
      return false;
    }
    target.value = "";

    const resizeFunc = async () => {
      return new Promise((resolve, reject) => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const img = new Image();
        const fr = new FileReader();
        fr.onload = e => {
          img.src = e.target!.result as string;
          e.preventDefault();
          img.onload = () => {
            let [width, height] = [img.width, img.height];
            if (img.width > this.imageMaxWidth) {
              width = this.imageMaxWidth;
              height = Math.round(height * (width / img.width));
            }
            [canvas.width, canvas.height] = [width, height];
            ctx!.drawImage(img, 0, 0, canvas.width, canvas.height);
            this.avatarImage = ctx!.canvas.toDataURL() as string;
            resolve(img);
          };
        };
        fr.readAsDataURL(file);
      });
    };
    try {
      await resizeFunc();
      await new EmployeeApi().updateAvatar({
        updateAvatar: { image: this.avatarImage } as UpdateAvatar,
        employeeId: this.storeInstance.getAuth()!.user.employeeId!
      });
    } catch (err) {
      let errMessage = "エラーが発生しました";
      if (err.response && err.response.data) {
        errMessage = err.response.data.detail;
      }
      this.storeInstance.setInstructionContent(InstructionLevel.Alert, errMessage);
    }
  }
}
</script>
